import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { setTrackLink } from '@vfit/shared/data-access';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const tagging = getTagging('personal data', 'fixed', client);

  const { trackView } = useTracking({
    event: ['checkout_step1'],
    event_label: 'personal information',
    opts: tagging?.opts,
    cartProduct: tagging?.trackingProduct,
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackView(trackView);
  setTrackLink(trackView, 'personal information');

  return null;
};

const TaggingNameFiscalCodeCard = withAnimationDelay()(TaggingComponent);

export default TaggingNameFiscalCodeCard;
